import { Component, OnInit, inject, Input } from '@angular/core';
import { PagamentosService } from '../api/services/pagamentos.service';
import { Pagination } from '../api/models/pagination.model';
import { CommonModule } from '@angular/common';
import { DataVoidComponent } from '../data-void/data-void.component';
import { PaginatorControlComponent } from '../paginator-control/paginator-control.component';

@Component({
  selector: 'app-lista-pagamentos',
  imports: [
    CommonModule,
    DataVoidComponent,
    PaginatorControlComponent
  ],
  providers: [
    PagamentosService
  ],
  standalone: true,
  templateUrl: './lista-pagamentos.component.html',
  styleUrl: './lista-pagamentos.component.scss'
})
export class ListaPagamentosComponent implements OnInit {
  pagamentoService = inject(PagamentosService);
  pagamentos: any;
  @Input() campanhaID: string = '';
  pagination: Pagination<any> = new Pagination<any>();

  ngOnInit(): void {
    this.getPaymentsByCampanhaID();
  }

  getPaymentsByCampanhaID() {
    const params = {
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      orderBy: 'id desc',
      CampanhaId: this.campanhaID,
      EstadoPagamentoENUM: 2
    }

    this.pagamentoService.listWithDomain(params).subscribe({
      next: (result) => {
        this.pagamentos = result.data;
        this.pagination = new Pagination<any>().deserialize(result);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getPaymentsByCampanhaID();
  }
}
